import { darken, saturate } from "polished";

import { useGenomeViewerStore } from "../../store/store.ts";
import { alignToRightPixelGrid } from "../../utils/graphics/align-to-pixel-grid.ts";

export function drawPhenotypeBullet(x: number, y: number, color: string) {
  const state = useGenomeViewerStore.getState();
  const ctx = state.ctx;
  const radius = 3;

  if (ctx == undefined) {
    return;
  }

  ctx.beginPath();
  ctx.fillStyle = color;
  ctx.strokeStyle = darken(0.15, saturate(0.1, color));
  ctx.lineWidth = 1;
  ctx.arc(alignToRightPixelGrid(x), alignToRightPixelGrid(y), radius, 0, 2 * Math.PI, false);
  ctx.stroke();
  ctx.fill();
}
